export default __webpack_public_path__ + "static/O0141-ec52205d732e079e1c47919c6b434bea.png";